import Alteration from "../../model/Alteration";
import AlterationsListElement from "./AlterationListElement";
import AlterationsListAddElement from "../alteration/AlterationsListAddElement";

interface IAlterationsListProps {
  idAlterationForm: number | undefined;
  data: Alteration[] | undefined;
  canEdit: boolean;
  onCreate: (
    name: string,
    type: string,
    idAlterationForm?: number | undefined
  ) => void;
  onUpdate: (name: string, id: number, type: string) => void;
  onDelete: (id: number, type: string) => void;
}

/*
  Component to manage the display of the existing ALTERATIONS list
*/
function AlterationsList({
  data,
  idAlterationForm,
  canEdit,
  onCreate,
  onUpdate,
  onDelete,
}: IAlterationsListProps) {
  return (
    <div className="alterations-list">
      {data &&
        data?.length > 0 &&
        data?.map((item) => {
          return (
            <AlterationsListElement
              key={item.id}
              data={item}
              canEdit={canEdit}
              onUpdate={onUpdate}
              onDelete={onDelete}
            />
          );
        })}
      {canEdit && (
        <AlterationsListAddElement
          idAlterationForm={idAlterationForm ?? -1}
          onCreate={onCreate}
        />
      )}
    </div>
  );
}

export default AlterationsList;
